namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHdAppColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoHdApp';
    }
}
